import { createApi } from '@reduxjs/toolkit/query/react';
import { createQuietBaseQuery } from './Shared/quietBaseQuery';
import type {
  LinkConfirmArgs,
  LinkConfirmResponse,
  LinkValidation,
} from './Shared/SetPasswordLinkPage';

export type ConfirmResetResponse = LinkConfirmResponse & {
  success: boolean;
  nextStep: 'CONFIRM_OTP';
};

export const PasswordResetApi = createApi({
  reducerPath: 'PasswordResetApi',
  baseQuery: createQuietBaseQuery('password-reset'),
  endpoints: builder => ({
    // POST so the token travels in the body — never in a path or a Referer.
    validateReset: builder.query<LinkValidation, { token: string }>({
      query: ({ token }) => ({
        url: '/2fa/password-reset/validate',
        method: 'POST',
        body: { token },
      }),
      keepUnusedDataFor: 0,
    }),
    confirmReset: builder.mutation<ConfirmResetResponse, LinkConfirmArgs>({
      query: body => ({
        url: '/2fa/password-reset/confirm',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useValidateResetQuery, useConfirmResetMutation } =
  PasswordResetApi;
